import _ from 'lodash';
import { WIDTH_POSTING } from '../index';
import { TableCell, TableLine } from '../../../../../components/Basic/Table';
import { Input } from '../../../../../components/Basic/Inputs';
import { Row } from '../../../../../components/Basic/Blocks';

const OrderBillItemsLine = ({
  MODES,
  FILTER,
  tab,
  index,
  listNameColor,
  LIST_MARKETS,
  order = [],
  billsMap = {},
  billItem = {},
  isAdmin = false,
  onChangeOrderData = () => _,
  onChangeBillItem = () => _,
  ...props
}) => {


  return (
    <>
      <TableLine style={{ ...(billItem.is_not_in_order && { backgroundColor: '#e0a1423b' }) }}>
        <TableCell width={WIDTH_POSTING[15]}  >
          {index}
        </TableCell>
        <TableCell width={WIDTH_POSTING[16]} center={true}>
          <Row
            style={{ cursor: 'pointer', padding: '5px 8px', fontWeight: 'bold', borderRadius: '6px', backgroundColor: listNameColor?.color }}
          >{listNameColor?.listName}</Row>
        </TableCell>
        <TableCell width={WIDTH_POSTING[0]} center={true}>
          {billItem.provider_sku}
        </TableCell>
        <TableCell width={WIDTH_POSTING[11]} >
          {billItem.name}
        </TableCell>
        <TableCell width={WIDTH_POSTING[15]} center={true}>
          <Input value={billItem.quantity}
            onBlur={value => onChangeBillItem({ billItemId: billItem._id, field: 'quantity', value: +value })} center />
        </TableCell>
        <TableCell width={WIDTH_POSTING[6]} center={true}>
          <Input value={billItem.purchase}
            onBlur={value => onChangeBillItem({ billItemId: billItem._id, field: 'purchase', value: +value })} center />
        </TableCell>
        <TableCell width={WIDTH_POSTING[0]} center={true}  >
          {billsMap[billItem.bill_id]?.number}
        </TableCell>
      </TableLine >
    </>
  );
};

export default OrderBillItemsLine;
